import request from '@/utils/request';
export function fillInCustomPhoneNumber(data) {
  return request({
    url: 'order/fill-in-custom-phone-number',
    method: 'post',
    data
  })
}

export function adminAllList(data) {
  return request({
    url: '/list-all',
    method: 'post',
    data
  });
}



/**
 * 订单列表
 * @param { page: 页码, count: 一页显示多少条, startTime: 开始时间, endTime: 结束时间, status: 0:待确认 1已确认 2已驳回 } data
 */
export function orderList(data) {
  return request({
    url: '/order/list',
    method: 'post',
    data
  });
}

/**
 * 订单详情
 * @param { id: 订单id, orderNo: 订单号 } data
 */
export function orderDetail(data) {
  return request({
    url: '/order/detail',
    method: 'post',
    data
  });
}
/**
 * 订单原始信息
 * @param {} data
 * @returns
 */
export function otherOrderDetail(data) {
  return request({
    url: '/order/other-order-detail',
    method: 'post',
    data
  });
}

/**
 * 财务审核订单
 * @param { id: 订单id, status: 0:待确认 1已确认 2已驳回, remark: 备注, content: 图片 } data
 */
export function orderUpdate(data) {
  return request({
    url: '/order/update',
    method: 'post',
    data
  });
}


/**
 * 售课
 * @param {
  * orderType: 1:峰会,2:项目,3:师训课,
  * summitCourseId: 峰会课程id,
  * customerTel: 客户手机号,
  * customerName: 客户姓名,
  * customerIdCard: 客户身份证,
  * payType: 1:微信 2:支付宝 3:现金 4:pos机代刷,
  * image: 支付凭证url(格式逗号分割),
  * orderOwnerId: 订单归属人id,
  * orderSubmitOwnerId： 订单提交人id,
  * customerParentId: 客户归属人id，
  * tradeNo: 支付凭证
 * } data
 */
export function createOrder(data) {
  return request({
    url: '/order/create',
    method: 'post',
    data
  });
}
/**
 * 客户列表
 * @param { page: 页码, count: 一页显示多少条, customerName: 顾客姓名, customerTel: 顾客电话, parentName: 归属人姓名 } data
 */
export function customerList(data) {
  return request({
    url: '/customer/list',
    method: 'post',
    data
  });
}

/**
 * 峰会列表
 * @param { page, count } data
 */
export function summitList(data) {
  return request({
    url: '/summit/list',
    method: 'post',
    data
  });
}

/**
 * 峰会课时列表
 * @param { page, count } data
 */
export function summitCourseList(data) {
  return request({
    url: '/summit-course/list',
    method: 'post',
    data
  });
}

/**
 * 师训课列表
 * @param { page, count } data
 */
export function projectTeacherCourseList(data) {
  return request({
    url: '/project-teacher-course/list',
    method: 'post',
    data
  });
}
/**
 * 项目设置列表
 * @param { page, count } data
 */
export function projectSetList(data) {
  return request({
    url: 'project-set/list',
    method: 'post',
    data
  });
}

/**
 * 订单详情
 * @param { id: 订单id, orderNo: 订单号 } data
 */
export function orderFollow(data) {
  return request({
    url: '/order/follow-up-create',
    method: 'post',
    data
  });
}

